<template>
 <ul class="px-[10px]">
    <BlockCard 
      v-for="value in filteredTransactions(blocks).items" 
      :key="value.id"
      :block="value" />
    <div v-if="blocks.total > maxResults" class="flex justify-end mt-[5px]">
      <RouterLink :to="{ name: 'resultsByType', params: { type: uiTypes.block }, query: $route.query }" 
        @click="loadMoreResults" 
        class="max-w-fit-content px-4 py-2 text-blue-dark font-jost-semibold text-right rounded-lg hover:bg-blue-700 transition-colors duration-200 block cursor-pointer">
        Show more
      </RouterLink>
    </div>
  </ul>
</template>

<script>
import { filteredTransactions } from '@/helpers/common';
import { MAX_SEARCH_RESULTS } from '@/helpers/constants';
import BlockCard from '@/components/common/BlockCard.vue';
import { UiTypes } from '@/utils/uiTypes';

export default {
  name: 'BlocksList',
  components: {
    BlockCard,
  },
  props: {
    blocks: {
      type: Object,
      default: () => ({ items: [] })
    }
  },
  data() {
    return {
      uiTypes: UiTypes,
      maxResults: MAX_SEARCH_RESULTS,
    };
  },
  methods: {
    filteredTransactions(list) {
      return filteredTransactions(list);
    },
    loadMoreResults() {
      // Navigate to AllResults page with blocks type
      this.$router.push({
        name: 'resultsByType',
        params: { type: this.uiTypes.block },
        query: this.$route.query
      });
    }
  }
}
</script>
